import { render, staticRenderFns } from "./vacancy.vue?vue&type=template&id=878ad43a"
import script from "./vacancy.vue?vue&type=script&lang=js"
export * from "./vacancy.vue?vue&type=script&lang=js"
import style0 from "./vacancy.vue?vue&type=style&index=0&id=878ad43a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports